// La app no tiene renderer de Markdown en ningún lado (arquitectura actual =
// texto plano en toda la UI pública), así que en vez de sumar una librería
// nueva solo para este campo, se limpia el texto a la hora de mostrarlo:
// se quitan los tokens de sintaxis Markdown y queda el contenido legible.
// No modifica el dato guardado — solo lo que se pinta en pantalla.
export function stripMarkdown(text) {
  if (!text) return text;
  return text
    .replace(/^#{1,6}\s+/gm, "")       // ## Encabezado -> Encabezado
    .replace(/\*\*\*(.+?)\*\*\*/g, "$1") // ***negrita+cursiva***
    .replace(/\*\*(.+?)\*\*/g, "$1")     // **negrita**
    .replace(/__(.+?)__/g, "$1")         // __negrita__
    .replace(/(?<!\*)\*(?!\*)(.+?)(?<!\*)\*(?!\*)/g, "$1") // *cursiva*
    .replace(/`{1,3}([^`]+)`{1,3}/g, "$1") // `código`
    .replace(/^>\s?/gm, "")              // > cita
    .replace(/^[-*+]\s+/gm, "• ");       // - item -> • item
}
